module.exports = __webpack_public_path__ + "img/ze-cable.a9e9fb66.jpg";